import React, { useMemo, useState } from "react";
import CountUp from "@/components/CountUp/CountUp";
import { CONTACTS } from "@/constants/contacts";

export default function ROICalculator() {
  const [sessoes, setSessoes] = useState(10);

  const results = useMemo(() => {
    const minutosPorDia = sessoes * 4.5;
    const horasPorMes = (minutosPorDia * 22) / 60;
    const sessoesAdicionais = Math.floor((horasPorMes * 60) / 50);
    const receita = sessoesAdicionais * 120;
    return { minutosPorDia, horasPorMes, sessoesAdicionais, receita };
  }, [sessoes]);

  return (
    <div className="glass roi-card" data-testid="roi-calculator">
      <p className="roi-label">Quantas sessões você atende por dia?</p>
      <div className="roi-value" data-testid="roi-sessions-value">
        {sessoes}
      </div>
      <input
        type="range"
        min={5}
        max={20}
        step={1}
        value={sessoes}
        onChange={(e) => setSessoes(parseInt(e.target.value, 10))}
        className="roi-slider"
        style={{
          background: `linear-gradient(to right,
            var(--color-accent) 0%,
            var(--color-accent) ${((sessoes - 5) / 15) * 100}%,
            var(--color-mid-purple) ${((sessoes - 5) / 15) * 100}%,
            var(--color-mid-purple) 100%)`,
        }}
        aria-label="Sessões por dia"
        data-testid="roi-slider"
      />

      <div className="roi-results">
        <div className="roi-result" data-testid="roi-result-minutes">
          <div className="roi-result-value">
            <CountUp value={results.minutosPorDia} format={(v) => Math.round(v).toString()} />
          </div>
          <div className="roi-result-label">minutos economizados/dia</div>
        </div>
        <div className="roi-result" data-testid="roi-result-hours">
          <div className="roi-result-value">
            <CountUp value={results.horasPorMes} format={(v) => v.toFixed(1)} />
            <span style={{ fontSize: 18, marginLeft: 4 }}>h</span>
          </div>
          <div className="roi-result-label">horas recuperadas/mês</div>
        </div>
        <div className="roi-result" data-testid="roi-result-sessions">
          <div className="roi-result-value">
            <CountUp value={results.sessoesAdicionais} format={(v) => Math.round(v).toString()} />
          </div>
          <div className="roi-result-label">sessões adicionais possíveis/mês</div>
        </div>
        <div className="roi-result" data-testid="roi-result-revenue">
          <div className="roi-result-value">
            R$ <CountUp value={results.receita} format={(v) => formatBRL(v)} />
          </div>
          <div className="roi-result-label">de receita potencial desbloqueada/mês</div>
        </div>
      </div>

      <p className="roi-disclaimer">
        *Estimativa baseada em média de documentação manual de 4,5 min/sessão
        economizados. Resultado real varia por perfil.
      </p>

      <a
        href={CONTACTS.app + "/signup"}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary btn-full"
        data-testid="roi-cta"
      >
        Começar a recuperar esse tempo
      </a>
    </div>
  );
}

function formatBRL(v) {
  return Math.round(v)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
